module.exports = __webpack_public_path__ + "static/media/MEDI.37ab28be.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/MEDI.jpg
// module id = 1767
// module chunks = 1